const apiUrl = process.env.REACT_APP_API_BASE_URL
const mapAPiKey = process.env.REACT_APP_MAP_API_KEY

export { mapAPiKey, apiUrl }
